import { CustomSelect } from '@wartek-id/select'

import { usePenetapanPredikatTableStore } from 'app/KinerjaShared/components/PenetapanPredikatTable/Provider'

const PAGINATION_SIZE_OPTIONS: Array<{ value: number; name: string }> = [
  { value: 10, name: '10 Nama' },
  { value: 50, name: '50 Nama' },
  { value: 100, name: '100 Nama' },
]

export function PaginationSize() {
  const { pageSize, setPageSize } = usePenetapanPredikatTableStore(
    ({ pageSize, setPageSize }) => ({ pageSize, setPageSize })
  )

  const selected = PAGINATION_SIZE_OPTIONS.find(
    (option) => option['value'] === pageSize
  )

  return (
    <CustomSelect
      options={PAGINATION_SIZE_OPTIONS}
      value={selected}
      className="text-nowrap"
      onChange={(selectedOption) => {
        setPageSize(Number(selectedOption['value']))
      }}
    />
  )
}
